var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isApplicationReady)?_c('div',{attrs:{"id":"app"}},[_c('ie-warn'),_c('navbar'),_c('router-view'),_c('main-footer'),(_vm.isLoginPopupVisible)?_c('login-popup'):_vm._e(),(_vm.isDrawerVisible)?_c('drawer'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }